<!--<div id="chartContainer2" style="height: 370px; width: 100%; margin-left:auto;margin-right:auto;"></div>-->

<div [hidden]='!myDoughnutChart' style="font-family: Exo;">
  <canvas id="myDoughnutChartCanvas">{{ myDoughnutChart }}</canvas>
</div>
